/* eslint-disable react/require-default-props */
import React, { createContext, useState, useMemo, useEffect, useCallback, useContext } from 'react';
const actionNotProvided = () => {
    console.warn('BrushawayContext: action not provided. Wrap your component in a BrushawayProvider.');
};
const defaultContext = {
    isOpen: false,
    toggleBrushaway: actionNotProvided,
    closeBrushaway: actionNotProvided,
    openBrushaway: actionNotProvided
};
export const BrushawayContext = createContext(defaultContext);
export function BrushawayProvider({ children, controlledOpen, onClose }) {
    const [isOpen, setIsOpen] = useState(Boolean(controlledOpen));
    const openBrushaway = useCallback(() => {
        setIsOpen(true);
    }, []);
    const closeBrushaway = useCallback(() => {
        setIsOpen(false);
        if (controlledOpen !== undefined) {
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }
    }, [controlledOpen, onClose]);
    const toggleBrushaway = useCallback(() => {
        const wasOpen = isOpen;
        setIsOpen((prev) => !prev);
        if (wasOpen && controlledOpen !== undefined) {
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }
    }, [isOpen, controlledOpen, onClose]);
    useEffect(() => {
        if (controlledOpen !== undefined) {
            setIsOpen(controlledOpen);
        }
    }, [controlledOpen]);
    const contextValue = useMemo(() => ({
        isOpen,
        toggleBrushaway,
        closeBrushaway,
        openBrushaway
    }), [isOpen, toggleBrushaway, closeBrushaway, openBrushaway]);
    return React.createElement(BrushawayContext.Provider, { value: contextValue }, children);
}
/**
 * Hook to access the BrushawayContext.
 * Must be used within a BrushawayProvider.
 */
export function useBrushaway() {
    return useContext(BrushawayContext);
}
